export type SemanticLabel = 'OffPeakEnd' | 'MidPeak1End' | 'PeakEnd' | 'MidPeak2End';
export type Season = 'summer' | 'winter';
export type SectionLabel = 'off-peak' | 'mid-peak' | 'peak';

export const MODE_TO_SECTION: Record<number, SectionLabel> = {
    1: 'off-peak',
    2: 'mid-peak',
    3: 'peak',
};

const SEMANTIC_ORDER: SemanticLabel[] = ['OffPeakEnd', 'MidPeak1End', 'PeakEnd', 'MidPeak2End'];

const findOffSlot = (peakSettings: any): number | null => {
    for (let n = 1; n <= 4; n++) {
        if (peakSettings?.[`Mode${n}`] === 1) return n;
    }
    return null;
};

const getSemanticSlots = (peakSettings: any): Record<SemanticLabel, number> | null => {
    const offSlot = findOffSlot(peakSettings);
    if (offSlot === null) return null;

    const result = {} as Record<SemanticLabel, number>;
    for (let i = 0; i < 4; i++) {
        const slot = ((offSlot - 1 + i) % 4) + 1;
        result[SEMANTIC_ORDER[i]] = slot;
    }
    return result;
};

export const detectSeason = (peakSettings: any): Season | null => {
    const offSlot = findOffSlot(peakSettings);
    if (offSlot === null) return null;

    const before = peakSettings?.[`Mode${offSlot === 1 ? 4 : offSlot - 1}`];
    const after = peakSettings?.[`Mode${offSlot === 4 ? 1 : offSlot + 1}`];

    if (before === 2 && after === 2) return 'summer';
    if (before === 3 && after === 3) return 'winter';
    return null;
};

const labelToModeValue = (label: SemanticLabel, season: Season): number => {
    if (label === 'OffPeakEnd') return 1;
    const isPeak = label === 'PeakEnd';
    return season === 'summer' ? (isPeak ? 3 : 2) : (isPeak ? 2 : 3);
};

export const normalizeForSend = (peakSettings: any): any => {
    const slots = getSemanticSlots(peakSettings);
    const season = detectSeason(peakSettings);
    if (!slots || !season) return peakSettings;

    const entries = SEMANTIC_ORDER.map(label => ({
        label,
        time: peakSettings[`EndMode${slots[label]}`],
    }));
    entries.sort((a, b) => a.time - b.time);

    const result = { ...peakSettings };
    entries.forEach((entry, i) => {
        const slotNum = i + 1;
        result[`EndMode${slotNum}`] = entry.time;
        result[`Mode${slotNum}`] = labelToModeValue(entry.label, season);
    });
    result.Mode5 = result.Mode1;
    result.Mode6 = result.Mode5;
    return result;
};
